module.exports = __webpack_public_path__ + "static/media/slider-bg.aca54e4d.jpg";